var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { Dropdown, Input, message } from 'antd';
import { ArrowRightOutlined, DownOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import services from 'services';
import EmptyComponent from 'components/EmptyComponent';
import Loader from 'components/AntEnhancement/Loader';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { Patient as PatientResource } from 'constants/resources';
import './style.css';
var PAGE_SIZE = 25;
var csvEscape = function (value) {
    var text = value.replace(/"/g, '""');
    return "\"".concat(text, "\"");
};
var downloadCsv = function (filename, rows) {
    var content = rows.map(function (row) { return row.map(csvEscape).join(','); }).join('\n');
    var blob = new Blob(["\uFEFF".concat(content)], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};
var genderTone = function (gender) {
    var key = (gender || '').toLowerCase();
    if (key === 'female')
        return 'is-female';
    if (key === 'male')
        return 'is-male';
    return 'is-neutral';
};
var Patients = function (props) {
    var _a, _b, _c;
    var t = props.translate;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var urlSearch = (searchParams.get('search') || '').trim();
    var _d = useState(1), pageNumber = _d[0], setPageNumber = _d[1];
    var _e = useState('primary_phone'), searchKey = _e[0], setSearchKey = _e[1];
    var _f = useState(urlSearch), draft = _f[0], setDraft = _f[1];
    var _g = useState(urlSearch), searchValue = _g[0], setSearchValue = _g[1];
    var _h = useState(false), exporting = _h[0], setExporting = _h[1];
    var debounceRef = useRef(undefined);
    var filters = useMemo(function () {
        var next = {};
        if (searchValue)
            next[searchKey] = searchValue;
        return next;
    }, [searchKey, searchValue]);
    var patientService = services.patientService, permissionService = services.permissionService;
    var _j = patientService.usePatients(pageNumber, filters), data = _j.data, isLoading = _j.isLoading, isFetching = _j.isFetching;
    var canAddPatient = permissionService.hasPermissionToAdd(PatientResource);
    var canShowPatient = permissionService.hasPermissionToShow(PatientResource);
    var patients = (data === null || data === void 0 ? void 0 : data.patients) || [];
    var meta = data === null || data === void 0 ? void 0 : data.meta;
    var totalCount = Number((_a = meta === null || meta === void 0 ? void 0 : meta.count) !== null && _a !== void 0 ? _a : 0);
    var pagesCount = (meta === null || meta === void 0 ? void 0 : meta.getPagesCount()) || 0;
    var from = Number((_b = meta === null || meta === void 0 ? void 0 : meta.from) !== null && _b !== void 0 ? _b : (patients.length ? (pageNumber - 1) * PAGE_SIZE + 1 : 0));
    var to = Number((_c = meta === null || meta === void 0 ? void 0 : meta.to) !== null && _c !== void 0 ? _c : (patients.length ? from + patients.length - 1 : 0));
    var searchFieldLabel = useMemo(function () {
        if (searchKey === 'code')
            return t('code');
        if (searchKey === 'system_code')
            return t('systemCode');
        return t('primaryPhone');
    }, [searchKey, t]);
    var searchPlaceholder = useMemo(function () {
        if (searchKey === 'code')
            return t('header.searchByCode');
        if (searchKey === 'system_code')
            return t('header.searchBySystemCode');
        return t('header.searchByPrimaryPhone');
    }, [searchKey, t]);
    useEffect(function () {
        clearTimeout(debounceRef.current);
        if (urlSearch)
            setSearchKey('primary_phone');
        setDraft(urlSearch);
        setSearchValue(urlSearch);
        setPageNumber(1);
    }, [urlSearch]);
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        setDraft(value);
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () {
            setPageNumber(1);
            setSearchValue(value);
        }, 500);
    };
    var searchFieldMenu = {
        selectedKeys: [searchKey],
        onClick: function (_a) {
            var key = _a.key;
            setSearchKey(key);
            setPageNumber(1);
        },
        items: [
            { key: 'code', label: t('code') },
            { key: 'system_code', label: t('systemCode') },
            { key: 'primary_phone', label: t('primaryPhone') }
        ]
    };
    var openPatient = function (patientId) {
        if (!canShowPatient)
            return;
        navigate("/patients/".concat(patientId));
    };
    var goToPatientForm = function () { return navigate('/patients/new'); };
    var exportPatients = function () { return __awaiter(void 0, void 0, void 0, function () {
        var collected, page, totalPages, pageData, rows, stamp, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (exporting)
                        return [2 /*return*/];
                    setExporting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    collected = [];
                    page = 1;
                    totalPages = 1;
                    _c.label = 2;
                case 2: return [4 /*yield*/, patientService.fetchPatientsPage(page, filters)];
                case 3:
                    pageData = _c.sent();
                    collected.push.apply(collected, (pageData.patients || []));
                    totalPages = Math.max(((_b = pageData.meta) === null || _b === void 0 ? void 0 : _b.getPagesCount()) || 1, 1);
                    page += 1;
                    _c.label = 4;
                case 4:
                    if (page <= totalPages) return [3 /*break*/, 2];
                    _c.label = 5;
                case 5:
                    if (collected.length === 0) {
                        message.warning(t('exportEmpty'));
                        return [2 /*return*/];
                    }
                    rows = __spreadArray([
                        [
                            t('id'),
                            t('code'),
                            t('systemCode'),
                            t('name'),
                            t('gender'),
                            t('primaryPhone')
                        ]
                    ], collected.map(function (patient) { return [
                        String(patient.getId()),
                        patient.getCode() || '',
                        patient.getSystemCode() || '',
                        patient.getName() || '',
                        patient.getTranslatedGender() || patient.getGender() || '',
                        patient.getPrimaryPhone() || ''
                    ]; }), true);
                    stamp = new Date().toISOString().slice(0, 10);
                    downloadCsv("patients-".concat(stamp, ".csv"), rows);
                    return [3 /*break*/, 8];
                case 6:
                    _a = _c.sent();
                    message.error(t('exportFailed'));
                    return [3 /*break*/, 8];
                case 7:
                    setExporting(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "patients-screen", "data-onboarding": "page-list", children: [_jsxs("header", { className: "patients-heading", children: [_jsxs("div", { className: "patients-heading__left", children: [_jsxs("div", { className: "patients-title-row", children: [_jsx("h1", { children: t('title') }), _jsx("span", { className: "patients-count", children: t('countBadge', { count: totalCount }) })] }), _jsx("p", { className: "patients-subtitle", children: t('subtitle') })] }), _jsxs("div", { className: "patients-heading__actions", children: [_jsxs("button", { type: "button", className: "patients-btn patients-btn--secondary", onClick: exportPatients, disabled: exporting, children: [_jsx(UploadOutlined, {}), _jsx("span", { children: exporting ? t('exporting') : t('export') })] }), canAddPatient && (_jsxs("button", { type: "button", className: "patients-btn patients-btn--primary", onClick: goToPatientForm, children: [_jsx(PlusOutlined, {}), _jsx("span", { children: t('newPatient') })] }))] })] }), _jsx("div", { className: "patients-toolbar", children: _jsxs("div", { className: "patients-search", "data-onboarding": "patient-search", children: [_jsx(SearchOutlined, { className: "patients-search__icon" }), _jsx(Input, { className: "patients-search__input", placeholder: searchPlaceholder, value: draft, onChange: onSearchValueChange, allowClear: true, "aria-label": searchPlaceholder }), _jsx("div", { className: "patients-search__divider", "aria-hidden": true }), _jsx(Dropdown, { menu: searchFieldMenu, trigger: ['click'], children: _jsxs("button", { type: "button", className: "patients-search__by", "aria-label": t('filters'), children: [_jsx("span", { className: "patients-search__by-label", children: t('searchBy') }), _jsx("span", { className: "patients-search__by-value", children: searchFieldLabel }), _jsx(DownOutlined, { className: "patients-search__by-caret" })] }) })] }) }), _jsxs("section", { className: "patients-table-card", children: [_jsx(Loader, { renderSpinner: isLoading && !data, className: "patients-list", children: patients.length === 0 ? (_jsxs("div", { className: "patients-empty", children: [_jsx(EmptyComponent, {}), _jsx("p", { children: t('empty') })] })) : (_jsx("div", { className: "patients-table-scroll", children: _jsxs("div", { className: [
                                    'patients-table',
                                    isFetching ? 'is-fetching' : '',
                                    canShowPatient ? '' : 'no-action'
                                ]
                                    .filter(Boolean)
                                    .join(' '), role: "table", children: [_jsxs("div", { className: "patients-table__head", role: "row", children: [_jsx("div", { className: "patients-cell is-id", role: "columnheader", children: t('id') }), _jsx("div", { className: "patients-cell is-code", role: "columnheader", children: t('code') }), _jsx("div", { className: "patients-cell is-system", role: "columnheader", children: t('systemCode') }), _jsx("div", { className: "patients-cell is-name", role: "columnheader", children: t('name') }), _jsx("div", { className: "patients-cell is-gender", role: "columnheader", children: t('gender') }), _jsx("div", { className: "patients-cell is-phone", role: "columnheader", children: t('primaryPhone') }), canShowPatient && (_jsx("div", { className: "patients-cell is-action", role: "columnheader", children: t('action') }))] }), patients.map(function (patient) {
                                        var tone = genderTone(patient.getGender());
                                        return (_jsxs("div", { role: "row", className: "patients-table__row", onClick: function () { return openPatient(patient.getId()); }, "data-testid": "patient-row-".concat(patient.getId()), children: [_jsx("div", { className: "patients-cell is-id", role: "cell", children: _jsx("span", { className: "patients-id", children: patient.getId() }) }), _jsx("div", { className: "patients-cell is-code", role: "cell", children: _jsx("span", { className: "patients-mono is-strong", children: patient.getCode() || '—' }) }), _jsx("div", { className: "patients-cell is-system", role: "cell", children: _jsx("span", { className: "patients-mono", children: patient.getSystemCode() || '—' }) }), _jsx("div", { className: "patients-cell is-name", role: "cell", children: _jsx("span", { className: "patients-name", children: patient.getName() || '—' }) }), _jsx("div", { className: "patients-cell is-gender", role: "cell", children: _jsx("span", { className: "patients-gender ".concat(tone), children: patient.getTranslatedGender() ||
                                                            patient.getGender() ||
                                                            '—' }) }), _jsx("div", { className: "patients-cell is-phone", role: "cell", children: _jsx("span", { className: "patients-mono", children: patient.getPrimaryPhone() || '—' }) }), canShowPatient && (_jsx("div", { className: "patients-cell is-action", role: "cell", children: _jsxs("button", { type: "button", className: "patients-row-link", "data-testid": "patient-show-action", onClick: function (event) {
                                                            event.stopPropagation();
                                                            openPatient(patient.getId());
                                                        }, children: [_jsx("span", { children: t('common:buttons.show') }), _jsx(ArrowRightOutlined, {})] }) }))] }, patient.getId()));
                                    })] }) })) }), patients.length > 0 && (_jsxs("div", { className: "patients-pager", children: [_jsx("div", { className: "patients-pager__meta", children: t('showingRange', { from: from, to: to, total: totalCount }) }), _jsxs("div", { className: "patients-pager__controls", children: [_jsx("button", { type: "button", className: "patients-pager__btn", disabled: pageNumber <= 1, onClick: function () { return setPageNumber(function (page) { return Math.max(1, page - 1); }); }, children: t('previous') }), _jsx("span", { className: "patients-pager__page", children: t('pageOf', { page: pageNumber, pages: Math.max(pagesCount, 1) }) }), _jsx("button", { type: "button", className: "patients-pager__btn", disabled: pagesCount > 0 ? pageNumber >= pagesCount : true, onClick: function () { return setPageNumber(function (page) { return page + 1; }); }, children: t('next') })] })] }))] })] }));
};
export default localeTranslator(Patients, 'patients');
